import Vue from 'vue';

Vue.directive('vertical-text', {
    bind: function (el, binding, vNode) {
        if (!/\<br\>/.test(el.innerHTML)) {
            el.innerHTML = el.innerHTML.split('').join('<br>')
        }
    }
})
